module.exports = __webpack_public_path__ + "static/desktop/img/case3.6e3c0349.png";